import React, { useEffect, useState } from "react";

const ItemRegionComponent = ({ item, region }) => {
  const [regionStatus, setRegionStatus] = useState(null);

  // Chang
  useEffect(() => {
    setRegionStatus(region.status);
  }, [region]);

  const editStatus = async (e) => {
    console.log(regionStatus);
    let response = await fetch(`${process.env.REACT_APP_API_URL}/Items/UpdateItemAviablaity`, {
      method: "POST",
      body: JSON.stringify({
        status: regionStatus === 1 ? 2 : 1,
        itemId: item.id,
        regionId: region.regionId,
      }),
      headers: { "Content-Type": "application/json" },
    }).catch((err) => console.log(err));

    if (response.status === 200) {
      setRegionStatus(regionStatus === 1 ? 2 : 1);
    }
  };
  return (
    <div className="w-1/4 p-2" key={region.regionId}>
      <label className="font-semibold mr-4 text-gray-900">{region.region}</label>
      <input type="checkbox" onChange={editStatus} checked={regionStatus === 1} />
    </div>
  );
};
const ItemExpandRegionPop = ({ item, setExpandItemRegion }) => {
  const [regions, setRegions] = useState([]);

  // using Effect To get Regions
  useEffect(() => {
    const getRegions = async () => {
      let response = await fetch(
        `${process.env.REACT_APP_API_URL}/Items/ItemsAviablaity/${item.id}`
      ).catch((err) => {
        console.log(err);
      });

      if (response.status === 200) {
        let data = await response.json();
        setRegions(data);
      }
    };
    getRegions();
  }, [item]);
  return (
    <>
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 shadow-lg rounded-lg  border-2">
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          type="button"
          onClick={() => setExpandItemRegion(null)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
        <div className="my-2">
          <h2 className="text-xl mb-4 text-center">
            <span className="underline text-blue-500">{item.name}</span>
          </h2>
          <form className="flex flex-col items-end my-2" method="POST">
            <div className="mb-2 flex flex-wrap flex-row-reverse w-full text-right">
              {regions.map((region) => {
                return (
                  <ItemRegionComponent
                    item={item}
                    region={region}
                    key={region.regionId}
                  ></ItemRegionComponent>
                );
              })}
            </div>

            <button
              type="button"
              className="bg-blue-500 text-white px-4 py-2 rounded-lg"
              onClick={() => setExpandItemRegion(null)}
            >
              حفظ
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ItemExpandRegionPop;
